<!-- VisionPendingAlert.vue -->
<template>
  <div v-if="show">
    <v-card elevation="0" rounded class="mt-2">
      <v-row class="report-overview mb-6 align-center ma-0 pa-0">
        <v-col class="pr-0" cols="1">
          <v-icon :color="iconColor" class="mr-0 pr-0" :size="iconSize">
            {{ icons.mdiAlertCircle }}
          </v-icon>
        </v-col>
        <v-col class="pl-0" cols="11">
          <span class="report-text">
            {{ $t(i18nKey) }}
          </span>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mdiAlertCircle } from '@mdi/js';

export default {
  name: 'VisionPendingAlert',
  props: {
    show: { type: Boolean, default: false },

    /**
     * 'workers' | 'offline'
     * Odabir koja se poruka prikazuje
     */
    variant: {
      type: String,
      required: true,
      validator: v => ['workers', 'offline'].includes(v)
    },

    iconColor: { type: String, default: '#FFBA13' },
    iconSize: { type: [Number, String], default: 30 }
  },
  computed: {
    i18nKey() {
      return this.variant === 'workers'
        ? 'assets.devices.deviceInfo.settings.vision.workersPending'
        : 'assets.devices.deviceInfo.settings.vision.offlineModePending';
    }
  },
  data() {
    return {
      icons: { mdiAlertCircle }
    };
  }
};
</script>

<style scoped>
.report-overview {
  background: #EFF7FF;
  border: 1px solid #FFBA13;
  background-color: #FFF8E1;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: small;
}
.report-text {
  color: #000000;
}
</style>
